<div *ngFor="let pageCode of pages" class="page-level" [ngStyle]="{ 'padding-left': level * 12 + 'px' }">
    <div *ngIf="pageMap[pageCode]" class="page-entry" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="none" *ngIf="pageMap[pageCode].children?.pages?.length">
            <button 
              mat-icon-button
              class="compact-icon-button"
              (click)="pageMap[pageCode].expanded = !pageMap[pageCode].expanded;$event.stopPropagation()">
            <mat-icon>{{ pageMap[pageCode].expanded ? 'expand_less' : 'chevron_right' }}</mat-icon>
            </button>
        </div>
      <div fxFlex 
      [ngClass]="pageCode == activePageCode ? 'active-page' : ''" 
      [ngClass]="pageMap[pageCode].children?.pages?.length ? 'sub-page-button-padding' : ''"  
      (click)="handlePageClick(pageMap[pageCode]);$event.stopPropagation()" class="cursor-pointer">
        <span >
            {{ pageMap[pageCode].name }}
          </span>
      </div>
    </div>
  
    <div *ngIf="pageMap[pageCode].expanded && pageMap[pageCode].children?.pages?.length">
      <app-hierarchical-page-menu
        [pageMap]="pageMap[pageCode].children"
        [pages]="pageMap[pageCode].children.pages"
        (pageSelected)="handlePageClick($event);$event.stopPropagation()"
        [level]="level + 1">
      </app-hierarchical-page-menu>
    </div>
  </div>
  